import script from "./HomeWatchlists.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeWatchlists.vue?vue&type=script&setup=true&lang=ts"

import "./HomeWatchlists.vue?vue&type=style&index=0&id=d6db8078&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6db8078"]])

export default __exports__